import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Styles from '../Style/Common.module.css';


const TQCertificates = (props)=>{
    const data = props.Improve;
    return(
        <div className={Styles.CertificatSec}>
            <Container>
                <Row>
                    <Col>
                        <div className={Styles.SectorsHeadaing + ' ' + Styles.centerAlight}>
                            <h2 data-aos="fade-up" data-aos-delay="200">Certificates & Accreditations</h2>
                        </div>
                        <ul>
                            <li data-aos="fade-up" data-aos-delay="400">
                                <figure>
                                    <img src={require('../../assest/images/ios_9001.webp')} />
                                </figure>
                            </li>
                            <li data-aos="fade-up" data-aos-delay="500">
                                <figure>
                                    <img src={require('../../assest/images/ios_14001.webp')} />
                                </figure>
                            </li>
                            <li data-aos="fade-up" data-aos-delay="600">
                                <figure>
                                    <img src={require('../../assest/images/ios_45001.webp')} />
                                </figure>
                            </li>
                            <li data-aos="fade-up" data-aos-delay="700">
                                <figure>
                                    <img src={require('../../assest/images/ios_17020.webp')} />
                                </figure>
                            </li>
                            
                            <li data-aos="fade-up" data-aos-delay="800">
                                <figure>
                                    <img src={require('../../assest/images/ios_17021.webp')} />
                                </figure>
                            </li>
                            
                            <li data-aos="fade-up" data-aos-delay="900">
                                <figure>
                                    <img src={require('../../assest/images/ios_17065.webp')} />
                                </figure>
                            </li>
                            <li data-aos="fade-up" data-aos-delay="900">
                                <figure>
                                    <img src={require('../../assest/images/iso_22000.webp')} />
                                </figure>
                            </li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default TQCertificates;